import { useSelector } from 'react-redux';
import { Box } from '@mui/material';

import PaperContainer from './components/PaperContainer';

export default function NoAccess() {
	const menuVisible = useSelector(state => state?.ui?.menuVisible);

	return (
		<div id="default-layout">
			<div className="main">
				<PaperContainer open={menuVisible}>
					<Box sx={{ display: 'flex', justifyContent: 'center', pt: 8 }}>
						<h3>Sorry, you don't have access to this page. Please try navigating elsewhere.</h3>
					</Box>
				</PaperContainer>
			</div>
		</div>
	);
}
